import React, { useState } from "react";
import { getHeadToHead } from "../../services/StatsService";

function HeadToHead({ teams }) {
    const [team1Id, setTeam1Id] = useState("");
    const [team2Id, setTeam2Id] = useState("");
    const [headToHead, setHeadToHead] = useState(null);
    const [h2hLoading, setH2hLoading] = useState(false);

    const fetchHeadToHead = async () => {
        if (!team1Id || !team2Id) return;
        if (team1Id === team2Id) { alert("Please select two different teams!"); return; }
        setH2hLoading(true);
        setHeadToHead(null);
        try {
            const data = await getHeadToHead(team1Id, team2Id);
            if (data) setHeadToHead(data);
        } catch (err) {
            console.error("Head to head fetch error", err);
        } finally {
            setH2hLoading(false);
        }
    };

    return (
        <div className="sfull">
            <div className="h2h-selector-bar">
                <select value={team1Id} onChange={(e) => setTeam1Id(e.target.value)} className="h2h-select">
                    <option value="">Select Team 1</option>
                    {teams.map(team => (
                        <option key={team.teamId} value={team.teamId}>{team.name} ({team.teamId})</option>
                    ))}
                </select>
                <span className="h2h-vs">VS</span>
                <select value={team2Id} onChange={(e) => setTeam2Id(e.target.value)} className="h2h-select">
                    <option value="">Select Team 2</option>
                    {teams.map(team => (
                        <option key={team.teamId} value={team.teamId}>{team.name} ({team.teamId})</option>
                    ))}
                </select>
                <button onClick={fetchHeadToHead} className="fbtn active h2h-btn">
                    Compare
                </button>
            </div>

            {h2hLoading && (
                <div className="sfull-empty">Loading...</div>
            )}

            {headToHead && !h2hLoading && (
                <div>
                    <div className="h2h-header">
                        <div className="h2h-team-col">
                            <img src={headToHead.team1PicURL} alt={headToHead.team1Name}
                                 className="h2h-team-img"
                                 onError={(e) => e.target.style.display = "none"}
                            />
                            <div className="h2h-team-name">{headToHead.team1Name}</div>
                            <div className="h2h-wins">{headToHead.team1Wins}</div>
                            <div className="h2h-wins-label">Wins</div>
                        </div>
                        <div className="h2h-center-col">
                            <div className="h2h-total-label">Total</div>
                            <div className="h2h-total-val">{headToHead.totalMatches}</div>
                            <div className="h2h-draws-label">Draws</div>
                            <div className="h2h-draws-val">{headToHead.draws}</div>
                        </div>
                        <div className="h2h-team-col">
                            <img src={headToHead.team2PicURL} alt={headToHead.team2Name}
                                 className="h2h-team-img"
                                 onError={(e) => e.target.style.display = "none"}
                            />
                            <div className="h2h-team-name">{headToHead.team2Name}</div>
                            <div className="h2h-wins">{headToHead.team2Wins}</div>
                            <div className="h2h-wins-label">Wins</div>
                        </div>
                    </div>

                    <table className="h2h-table">
                        <thead>
                        <tr>
                            <th className="h2h-th-team1">{headToHead.team1Name}</th>
                            <th className="h2h-th-stat">Stat</th>
                            <th className="h2h-th-team2">{headToHead.team2Name}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {[
                            { label: "Total Runs", v1: headToHead.team1TotalRuns, v2: headToHead.team2TotalRuns },
                            { label: "Avg Runs", v1: headToHead.team1AvgRuns?.toFixed(1), v2: headToHead.team2AvgRuns?.toFixed(1) },
                            { label: "Highest Score", v1: headToHead.team1HighestScore, v2: headToHead.team2HighestScore },
                            { label: "Total Sixes", v1: headToHead.team1TotalSixes, v2: headToHead.team2TotalSixes },
                            { label: "Total Fours", v1: headToHead.team1TotalFours, v2: headToHead.team2TotalFours },
                        ].map((row, i) => (
                            <tr key={i} className="h2h-tr">
                                <td className="h2h-td-v1">{row.v1?.toLocaleString()}</td>
                                <td className="h2h-td-stat">{row.label}</td>
                                <td className="h2h-td-v2">{row.v2?.toLocaleString()}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}

export default HeadToHead;